/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui'

const BlueLine = () => (
  <div
    sx={{
      width: '40px',
      height: '6px',
      backgroundColor: 'blueLine',
      mt: 3,
      mb: 2,
    }}
  />
)

export default BlueLine
